import React from "react";
import { Form, Formik, FieldArray } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Text,
  FormErrorMessage,
  Flex,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { principalDirectorsSchema } from "../utils/formValidationSchema";
import { setPrincipalDirectors } from "../redux/slices/corporateRegistrationSlice";

// Reusable component for form fields
const DirectorFormFields = ({
  index,
  errors,
  touched,
  handleBlur,
  handleChange,
  values,
}) => {
  const fields = [
    { name: "title", label: "Title" },
    { name: "surname", label: "Surname" },
    { name: "firstName", label: "First Name" },
    { name: "phoneNumber", label: "Phone Number" },
    { name: "address", label: "Address" },
    { name: "specialITInterest", label: "Special IT Interest" },
  ];

  return fields.map(({ name, label }) => (
    <GridItem key={name}>
      <FormControl
        isInvalid={errors?.[index]?.[name] && touched?.[index]?.[name]}
      >
        <FormLabel>{label}</FormLabel>
        <Input
          name={`principalDirectors.${index}.${name}`}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values[index][name]}
        />
        <FormErrorMessage>{errors?.[index]?.[name]}</FormErrorMessage>
      </FormControl>
    </GridItem>
  ));
};

const CorporateOwnerForm = ({ handlePrevious, handleNext }) => {
  const dispatch = useDispatch();
  const principalDirectors = useSelector(
    (state) => state?.companyRegistration?.principalDirectors || []
  );

  const initialValues = {
    principalDirectors: principalDirectors.length
      ? principalDirectors
      : [
          {
            title: "",
            surname: "",
            firstName: "",
            phoneNumber: "",
            address: "",
            specialITInterest: "",
          },
        ],
  };

  const handleSubmit = (values) => {
    dispatch(setPrincipalDirectors(values.principalDirectors));
    handleNext(values);
  };

  return (
    <Box px="50px">
      <Text fontSize="20px" fontWeight="700">
        Kindly provide the principal director details below
      </Text>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object({
          principalDirectors: principalDirectorsSchema,
        })}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form>
            <FieldArray name="principalDirectors">
              {({ push, remove }) => (
                <>
                  {values.principalDirectors.map((_, index) => (
                    <Box key={index} border="1px solid #ccc" p={4} mb={4}>
                      <Text fontWeight="bold">Director {index + 1}</Text>
                      <Grid
                        templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
                        gap={6}
                      >
                        <DirectorFormFields
                          index={index}
                          errors={errors.principalDirectors}
                          touched={touched.principalDirectors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          values={values.principalDirectors}
                        />
                      </Grid>
                      {values.principalDirectors.length > 1 && (
                        <Button
                          mt={4}
                          colorScheme="red"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Button
                    colorScheme="blue"
                    mt={4}
                    onClick={() => push(initialValues.principalDirectors[0])}
                  >
                    Add Another Director
                  </Button>
                </>
              )}
            </FieldArray>

            <Flex justifyContent="space-between" mt={10}>
              <Button bg="#A6A6A6" color="#FFFFFF" onClick={handlePrevious}>
                Back
              </Button>
              <Button bg="#23A455CC" color="#FFFFFF" type="submit">
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CorporateOwnerForm;
